__turbopack_context__.v({
  "container": "FormNumberModifierInput-module-scss-module__q2ZnZq__container",
  "disabled": "FormNumberModifierInput-module-scss-module__q2ZnZq__disabled",
  "inputContainer": "FormNumberModifierInput-module-scss-module__q2ZnZq__inputContainer",
  "modifierIcon": "FormNumberModifierInput-module-scss-module__q2ZnZq__modifierIcon",
  "spacer": "FormNumberModifierInput-module-scss-module__q2ZnZq__spacer",
  "valid": "FormNumberModifierInput-module-scss-module__q2ZnZq__valid",
});
